/**
 * 从 URL 路径中提取对话ID
 * 支持 /conversation/:id 格式
 */
export function getConversationIdFromPath(pathname) {
  if (!pathname || !pathname.includes('/conversation/')) return null;
  const parts = pathname.split('/');
  const index = parts.indexOf('conversation');
  if (index !== -1 && parts.length > index + 1) {
    return parts[index + 1];
  }
  return null;
}